<div class="tw-mt-5 tw-flex tw-justify-center">
  <div>
    <img src="../../images/logo-dark@2x.png" class="logo" alt="Fallen Vault" />
    <p class="tw-text-center tw-my-4">
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin bwi-2x tw-text-muted"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    </p>
  </div>
</div>
